// src/utils/helpers/avatarFallback.ts

export function getDefaultAvatar(type: "user" | "group" = "user") {
  const fallback = "/defaults/fallback.png";

  const envAvatar =
    type === "group"
      ? process.env.NEXT_PUBLIC_DEFAULT_GROUP_AVATAR
      : process.env.NEXT_PUBLIC_DEFAULT_USER_AVATAR;

  return envAvatar?.trim() ? envAvatar : fallback;
}
